import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import './css/NavBar.css';

function NavBar(on) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(true); // Slide up on mount
    }, []);

    return (
        <nav className={`navbar slide-navbar ${visible ? 'slide-up' : 'slide-down'}`}>
            <ul className="nav-links">
                <li>
                    <Link to="/" className="nav-link">
                        <FontAwesomeIcon className='icon' icon={faHome} title="Home" />
                    </Link>
                </li>
                <li>
                    <Link to="/current-events" className="nav-link">
                        <FontAwesomeIcon className='icon' icon={faCalendarAlt} title="Events" />
                    </Link>
                </li>
                <li>
                    <Link to="/create-new-cup" className="nav-link">
                        <FontAwesomeIcon className='icon' icon={faPlusCircle} title="NewEvent" />
                    </Link>
                </li>
                <li>
                    <Link to="/players" className="nav-link">
                        <FontAwesomeIcon className='icon' icon={faUsers} title="Players" />
                    </Link>
                </li>
                <li>
                    <Link to="/settings" className="nav-link">
                        <FontAwesomeIcon className='icon' icon={faCog} title="Settings" />
                    </Link>
                </li>
            </ul>
        </nav>
    );
}

export default NavBar;